module.exports = __webpack_public_path__ + "static/media/seek-forward-15.039fdc36.svg";